﻿export default class QuickAddControl {
    constructor(action, resourcesHandler, layerSettingsHandler, menuContainer, rootURL, classId, mapControl, editControl, addActions) {
        this.action = action;
        this.resourcesHandler = resourcesHandler;
        this.layerSettingsHandler = layerSettingsHandler;
        this.elementId = 'map-action-' + this.classId + '-' + this.action.Id;
        this.menuContainer = menuContainer;
        this.rootURL = rootURL;
        this.classId = classId;
        this.mapControl = mapControl;
        this.editControl = editControl;
        this.addActions = addActions;
    }

    init() {
        if (this.addActions.length == 1) {
            this.menuContainer.append(this._getActionButtonTemplate());
            document.getElementById(this.elementId).addEventListener('click', this._actionButtonClickHandler());
        } else {
            this.menuContainer.append(this._getActionButtonTemplate());

            $('#' + this.elementId).attr("data-toggle", "dropdown");
            $('#' + this.elementId).parent().addClass('dropleft');
            $('#' + this.elementId).parent().addClass('dropup');
            $('#' + this.elementId).parent().append('<div class="dropdown-menu quick-add" style="max-height:' + ($(window).height() * 0.5).toString() + 'px; overflow-y:auto; overflow-x: hidden; top: 0; bottom: 1rem; left: unset; right: 3rem;height: fit-content;"></div>');

            for (var i = 0; i < this.addActions.length; i++) {

                var _layer = this.layerSettingsHandler.getLayerSettings(this.addActions[i].IdMapLayer);
                if (_layer == null) {
                    continue;
                }
                var layerName = this.addActions[i].Text != null && this.addActions[i].Text.trim() != '' && this.addActions[i].Text != 'ADD' ? this.addActions[i].Text : _layer.Title;
                $('#' + this.elementId).parent().find(".dropdown-menu").append(
                    '<a class="dropdown-item" data-layer="' + this.addActions[i].IdMapLayer + '" href="javascript:void(0)">'
                    + layerName + '</a>'
                );

                $('#' + this.elementId).parent().find(".dropdown-item[data-layer='" + this.addActions[i].IdMapLayer + "']").click(this._getAddFeatureHandler(i));
            }

            new ResizeSensor(jQuery('body'), function () {
                if ($(".quick-add.dropdown-menu").hasClass("show")) {
                    $(".quick-add.dropdown-menu").removeClass("show");
                    $(".quick-add.dropdown-menu").parent().find("a").attr("aria-expanded", "false");
                }
                $(".quick-add.dropdown-menu").css({ "max-height": (($(window).height() * 0.5).toString() + "px") });
            });
        }
    }

    _getAddFeatureHandler(actionId) {
        const mapLayerId = this.addActions[actionId].IdMapLayer;
        const action = this.addActions[actionId];
        var handler = () => {
            if ($(".quick-add.dropdown-menu").hasClass("show")) {
                $(".quick-add.dropdown-menu").removeClass("show");
                $(".quick-add.dropdown-menu").parent().find("a").attr("aria-expanded", "false");
            }

            var layer = this.mapControl.layerHandler.getLayerById(mapLayerId)[0];
            if (!layer.isVisible()) {
                $event.notify(eventTypes.LAYER_VISIBILITY_CHANGED, { layerId: this.addActions[0].IdMapLayer, visible: true }, this, this.classId);
                layer.setVisible(true);
            }

            this.editControl.startInsert(mapLayerId, null, null, action);
        }

        return handler;
    }

    _actionButtonClickHandler() {
        return () => {
            let layer = this.mapControl.layerHandler.getLayerById(this.addActions[0].IdMapLayer)[0];
            if (!layer.isVisible()) {
                $event.notify(eventTypes.LAYER_VISIBILITY_CHANGED, { layerId: this.addActions[0].IdMapLayer, visible: true }, this, this.classId);
                layer.setVisible(true);
            }

            this.editControl.startInsert(this.addActions[0].IdMapLayer, null, null, this.addActions[0]);
        };
    }

    _getActionButtonTemplate() {
        let div = document.createElement('div');
        div.innerHTML = `<li>
                            <a class="btn map-menu-item" id="` + this.elementId + `" title="` + this._getTitle() + `">
                                <i class="` + this.action.Icon + `"></i>
                            </a>
                        </li>`;
        return div.firstChild;
    }

    _getTitle() {
        if (this.action.Title != null && this.action.Title != '') {
            return this.action.Title;
        }

        return this.resourcesHandler.get('SubType_' + this.action.SubType);
    }
}